<template>
    <ckeditor
        :config="editorConfig"
        :value="this.value"
        :editor="editor"
        @input="emit">
    </ckeditor>
</template>

<script>

import Vue from "vue";

const customColorPalette = [
    {
        color: 'rgb(0, 0, 0)',
        label: 'Black'
    },
    {
        color: 'rgb(77, 77, 77)',
        label: 'Dim grey'
    },
    {
        color: 'rgb(153, 153, 153)',
        label: 'Grey'
    },
    {
        color: 'rgb(230, 230, 230)',
        label: 'Light grey'
    },
    {
        color: 'rgb(255, 255, 255)',
        label: 'White',
        hasBorder: true
    },
    {
        color: 'rgb(230, 76, 76)',
        label: 'Red'
    },
    {
        color: 'rgb(230, 153, 76)',
        label: 'Orange'
    },
    {
        color: 'rgb(230, 230, 76)',
        label: 'Yellow'
    },
    {
        color: 'rgb(153, 230, 76)',
        label: 'Light green'
    },
    {
        color: 'rgb(76, 230, 76)',
        label: 'Green'
    },
    {
        color: 'rgb(76, 230, 153)',
        label: 'Aquamarine'
    },
    {
        color: 'rgb(76, 230, 230)',
        label: 'Turquoise'
    },
    {
        color: 'rgb(76, 153, 230)',
        label: 'Light blue'
    },
    {
        color: 'rgb(76, 76, 230)',
        label: 'Blue'
    },
    {
        color: 'rgb(153, 76, 230)',
        label: 'Purple'
    }
];

import CKEditor   from 'ckeditor4-vue';
Vue.use(CKEditor);

export default {
    components: {
        ckeditor: CKEditor.component
    },
    name: "ckeditor-proposal",
    props  : ['value', 'options','proposal'],
    data() {
        return {
            extraPlugins : 'widget',
            editor:CKEditor,
            editorConfig: {
                height: 800,
                resize_enabled: false,
                removePlugins:'easyimage,image,cloudservices,exportpdf',
                extraPlugins : 'pastefromword,pastefromgdocs,uploadimage,uploadwidget,image2,spreadsheet,widget,ckeditor-gwf-plugin,liststyle,clipboard,pastetools',
                spreadsheet_licenseKey: 'OUy6pyCG3CO3vwA4qpzC/dmTyNKCqa06csaf1qrn+vLgr3tcnM773OLBPdJzLMvv7Ncq5qqM5lNuqMWSEClM8z3rAnRz8G4/+Rj2ac/E9GJ3fAi5rGEqKHPWAfzGOABljrCxnCwLOXj5EwCRZ629Zt10iLiWnMz55daF1g==',
                uploadUrl: '/api/ckeditor-proposal-resource-files/'+this.proposal.project_id+'/'+this.proposal.id,
                autoEmbed_widget: 'addSignature,addInitials,addDate,contactName,contactEmail,contactCompany,projectAddress,baseBid,spreadsheet',
                autoUpdateElement: true,
                allowedContent:true,
                removeButtons:'Save,Source,ExportPdf,Preview,Print,Replace,About,ShowBlocks,SelectAll,Form,TextField,Textarea,Select,Button,ImageButton,CreateDiv,Link,Unlink,Anchor,Iframe,HiddenField,Flash',
                language: 'en',
                fontSize: {
                    options: ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
                },
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:full',
                        'imageStyle:side'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                    ],
                    tableProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    },
                    tableCellProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    }
                },
                fontBackgroundColor: {
                    colors: customColorPalette
                },
                fontColor: {
                    colors: customColorPalette
                },
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                pasteFromWordNumberedHeadingToList:true,
                pasteFromWord_inlineImages: true,
                pasteFromWordRemoveStyles: false,
                pasteFromWordRemoveFontStyles: false,
                spreadsheet_enableAutoConversion: true,
                spreadsheet_cellReferencesLimit: 0,
                contentsCss:[CKEDITOR.getUrl('ckeditor-font.css')],
                font_names:'GoogleWebFonts;Architxt/architxt;Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif;',
                bodyClass: 'document-editor',
                pasteTools_keepZeroMargins:true,
                tabSpaces: 4,
                font_defaultLabel:'Verdana',
                fontSize_defaultLabel:'13'
            },
            oldEditorValue:this.value,
            customConfig:'',
        };
    },
    created() {

    },
    mounted(){
        Bus.$on('templateIsSelected', data => {
            this.oldEditorValue = data;
        });
        Bus.$on('updatedSectionTemplate', data => {
            this.oldEditorValue = data;
        });
        CKEDITOR.on("instanceReady", function(event) {
            for (var i in CKEDITOR.instances) {
                CKEDITOR.instances[i].on("fileUploadResponse", function (event) {
                    var images = CKEDITOR.instances[i].document.getElementsByTag('img')
                    images.$[images.$.length - 2].setAttribute('src', JSON.parse(event.data.fileLoader.xhr.response.split('|')[0]).url);
                    images.$[images.$.length - 2].setAttribute('data-cke-saved-src', JSON.parse(event.data.fileLoader.xhr.response.split('|')[0]).url);
                    images.$[images.$.length - 2].setAttribute('style','max-width:500px;');
                    images.$[images.$.length - 2].setAttribute('style','height:auto;');
                    var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="500" height="auto" style="max-width:100% !important" src="' + JSON.parse(event.data.fileLoader.xhr.response.split('|')[0]).url + '" /></span>';
                    CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
                    var range = CKEDITOR.instances[i].createRange();
                    range.moveToPosition( range.root, CKEDITOR.POSITION_BEFORE_END );
                    CKEDITOR.instances[i].getSelection().selectRanges( [ range ] );
                    Bus.$emit('newEditorData', CKEDITOR.instances[i].getData());
                });

                CKEDITOR.instances[i].on('paste', function(evt) {
                    evt.data.dataValue = evt.data.dataValue.replace(/&nbsp;&nbsp;/g,'&nbsp;');
                    evt.data.dataValue = evt.data.dataValue.replace(/<p><\/p>/g,'');
                    evt.data.dataValue = evt.data.dataValue.replace(/<\/?a[^>]*>/g, '');
                    evt.data.dataValue = evt.data.dataValue.replace('value="50"', '');
                    evt.data.dataValue = evt.data.dataValue.replace('value="1000"', '');
                    evt.data.dataValue = evt.data.dataValue.replace('<div aria-label="Page Break" class="cke_pagebreak" contenteditable="false" data-cke-display-name="pagebreak" data-cke-pagebreak="1" style="page-break-after:always" title="Page Break"></div>','');
                }, null, null, 9);
            }


        });
        let self = this;
        CKEDITOR.on("instanceReady", function(event) {
            event.editor.on("beforeCommandExec", function(event) {
                if (event.data.name == "paste") {
                    event.editor._.forcePasteDialog = true;
                }
                if (event.data.name == "pastetext" && event.data.commandData.from == "keystrokeHandler") {
                    event.editor._.forcePasteDialog = true;
                }
            });
            event.editor.on( 'change', function() {
               // if(this.oldEditorValue !== event.editor.getData()){
               //     self.$emit('changesOccur', true);
               // }
            } );
        });
        Bus.$on('toolButton', data => {
            CKEDITOR.currentInstance.widgets.add( data['button'], {
                inline: true,
                template: '<span class="'+data['button']+' cke_widget_element" data-cke-widget-upcasted="1"  style="pointer-events: none;border: 1px solid #01b1af;font-size: 12px;padding: 1px 5px;color: #01b1af;text-align: center;width: 170px;margin-right:3px;-webkit-user-modify: read-only;user-modify: read-olny;-moz-user-modify: read-only;maring-left:5px" disabled>'+data['text']+'</span>',
                upcast: function( element ) {
                    return element.name == 'span' && element.hasClass( data['button'] );
                },
                init: function() {
                }
            } );

            CKEDITOR.currentInstance.execCommand(data['button']);

        });
    },
    watch  : {
        // options() {
        //     this.atValues = this.options.map(this.mapValues);
        // },
    },
    methods: {
        emit(value, batch) {
            this.$emit('input', value);
        }
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 200px;
}

a.cke_button_off:hover, a.cke_button_off:focus, a.cke_button_off:active {
    background: #e5e5e5;
    border: 1px #bcbcbc solid;
    padding: 2px 5px !important;
}
a.cke_button_expandable.cke_button_off:hover, a.cke_button_expandable.cke_button_off:focus, a.cke_button_expandable.cke_button_off:active {
    padding: 2px 2px !important;
}
.cke_toolgroup{
    display:contents !important;
}
.cke_editable p, .cke_editable div{
    margin:0 !important;
}
.cke_notification_warning {
    display: none !important;
}

div#gwf-popup {
    width: 400px !important;
    color: #333 !important;
}

div#gwf-popup h5 {
    margin-bottom:5px !important;
}

div#gwf-popup #fontNamesInput {
    padding: 10px !important;
    border: 1px solid silver !important;
}

div#gwf-popup button {
    font-size: 15px !important;
    background: #01b1af !important;
    color: #fff !important;
    padding: 5px !important;
    margin-top: 10px !important;
    margin-right: 10px !important;
    border-radius: 5px !important;
}

.my-signature-preview {
    background-color: #fff !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    padding-left: 14px !important;
}

.my-signature-font {
    font-size: 30px !important;
}

div#font-picker {
    width: 466px !important;
    margin-top: 10px !important;
    height: 35px !important;
    margin-left: -15px !important;
    background-color: white !important;
}

div#font-picker .dropdown-button {
    background: white !important;
}

</style>
